const VALID_IMG_RE = /^<img\b/i;

/**
 * Validates an impression tag string.
 * Returns an error message if invalid, or null if valid (including empty string).
 */
export const validateImpressionTag = (value: string): string | null => {
  const trimmed = value.trim();
  if (!trimmed) return null;
  if (!VALID_IMG_RE.test(trimmed)) return 'Tag must start with <img or <IMG';
  try {
    const doc = new DOMParser().parseFromString(trimmed, 'text/html');
    const el = doc.body.firstElementChild;
    if (!el || el.tagName.toLowerCase() !== 'img') return 'Invalid <img> tag structure';
    if (doc.body.textContent?.trim()) return 'Tag has unexpected content after closing >';
  } catch {
    return 'Invalid tag format';
  }
  return null;
};

/**
 * Returns the trimmed tag ready for export injection, or '' if invalid/disabled.
 */
export const getImpressionTagHTML = (impressionTagData?: {
  hasImpressionTag?: boolean;
  tagContent?: string;
}): string => {
  if (!impressionTagData?.hasImpressionTag || !impressionTagData?.tagContent) return '';
  const trimmed = impressionTagData.tagContent.trim();
  return validateImpressionTag(trimmed) === null ? trimmed : '';
};
